import React, { useState } from 'react';
import SingleStudentSearchCard from '../commonComponents/SingleStudentSearchCard';
import StudentList from "../../otherCharges/studentList";
import { fetchAllPostPromisedData } from '../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../common/constant';
import ALoader from '../../../common/a-loader';

const StudentSearchAndListing = () => {

    const [studentList, setStudentList] = useState([]);
    const [loading, setLoading] = useState(false);

    const searchHandler = async (searchCriteria) => {
        try {
            setLoading(true);
            const resp = await fetchAllPostPromisedData(`${endpoint.centralizedAdmission.searchStudent}`, searchCriteria);
            if (resp?.code === 200) {
                setStudentList(resp?.data);
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const crossHandler = () => setStudentList([]);

    return (
        <>
            {loading && <ALoader position="fixed" />}

            <SingleStudentSearchCard
                searchHandler={searchHandler}
                crossHandler={crossHandler}
            />
            <StudentList
                rowsData={studentList}
                showPagination={false}
                isCentralizedAdmCase ={true}
            />

        </>
    );
}

export default StudentSearchAndListing;